export const MOOD_API_SERVICE_LINK = 'https://metocean-on-demand.com/api';
